
/* =========================================================
   GET ROOM CATEGORY NAME
========================================================= */

export const getRoomCategoryName = (room) => {
  const category =
    room?.roomCategory?.name ||
    room?.roomCategory?.title ||
    room?.category?.name ||
    room?.category?.title ||
    room?.roomCategoryName ||
    room?.categoryName ||
    room?.category ||
    room?.roomTypeCategory ||
    room?.type ||
    "";

  if (
    typeof category === "object"
  ) {
    return (
      category?.name ||
      category?.title ||
      "Other"
    );
  }

  const value =
    String(category).trim();

  return value || "Other";
};


/* =========================================================
   FORMAT CATEGORY LABEL
========================================================= */

export const formatCategoryName = (value) => {
  if (!value) {
    return "Other";
  }

  const text =
    String(value)
      .trim()
      .replace(/\s+/g, " ");

  return text
    .toLowerCase()
    .replace(/\b\w/g, (letter) =>
      letter.toUpperCase()
    );
};
